'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getAnalyticsSaga;

var _effects = require('redux-saga/effects');

var _cookiesJs = require('cookies-js');

var _cookiesJs2 = _interopRequireDefault(_cookiesJs);

var _setAnalyticsSaga = require('./setAnalyticsSaga');

var _setAnalyticsSaga2 = _interopRequireDefault(_setAnalyticsSaga);

var _selectAnalytics = require('../../selectors/context/selectAnalytics');

var _getUUID = require('../../helpers/getUUID');

var _getUUID2 = _interopRequireDefault(_getUUID);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getAnalyticsSaga);

function getAnalyticsSaga() {
    var analytics, jsonCookie, cookie, uuid, queryString, params, hasUtmParams;
    return regeneratorRuntime.wrap(function getAnalyticsSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)((0, _selectAnalytics.selectAnalytics)());

                case 2:
                    analytics = _context.sent;

                    if (analytics) {
                        _context.next = 38;
                        break;
                    }

                    analytics = {};
                    jsonCookie = _cookiesJs2.default.get('_metrix');
                    cookie = null;

                    if (jsonCookie) {
                        cookie = JSON.parse(jsonCookie);
                    }

                    if (!(cookie && cookie.analytics)) {
                        _context.next = 12;
                        break;
                    }

                    analytics = cookie.analytics;
                    _context.next = 36;
                    break;

                case 12:
                    uuid = (0, _getUUID2.default)();

                    analytics.uuid = uuid;

                    queryString = window.location.search.toLowerCase();
                    params = new URLSearchParams(queryString);
                    hasUtmParams = false;


                    if (!analytics.source) {
                        analytics.source = params.get('utm_source');
                        if (analytics.source) {
                            analytics.source = analytics.source.toLowerCase();
                            hasUtmParams = true;
                        }
                    }
                    if (!analytics.medium) {
                        analytics.medium = params.get('utm_medium');
                        if (analytics.medium) {
                            analytics.medium = analytics.medium.toLowerCase();
                            hasUtmParams = true;
                        }
                    }
                    if (!analytics.campaign) {
                        analytics.campaign = params.get('utm_campaign');
                        if (analytics.campaign) {
                            analytics.campaign = analytics.campaign.toLowerCase();
                            hasUtmParams = true;
                        }
                    }
                    if (!analytics.content) {
                        analytics.content = params.get('utm_content');
                        if (analytics.content) {
                            analytics.content = analytics.content.toLowerCase();
                            hasUtmParams = true;
                        }
                    }
                    if (!analytics.keyword) {
                        analytics.keyword = params.get('utm_keyword');
                        if (analytics.keyword) {
                            analytics.keyword = analytics.keyword.toLowerCase();
                            hasUtmParams = true;
                        }
                    }
                    if (!analytics.adgroup) {
                        analytics.adgroup = params.get('utm_adgroup');
                        if (analytics.adgroup) {
                            analytics.adgroup = analytics.adgroup.toLowerCase();
                            hasUtmParams = true;
                        }
                    }

                    if (hasUtmParams) {
                        _context.next = 36;
                        break;
                    }

                    if (document.referrer && document.referrer.length > 0) {
                        if (document.referrer.indexOf('.') !== -1) {
                            analytics.source = new URL(document.referrer).hostname.split('.').reverse()[1].toLowerCase();
                        } else {
                            analytics.source = new URL(document.referrer).hostname;
                        }
                    }

                    _context.t0 = analytics.source;
                    _context.next = _context.t0 === 'google' ? 28 : _context.t0 === 'bing' ? 28 : _context.t0 === 'duckduckgo' ? 28 : _context.t0 === 'yandex' ? 28 : _context.t0 === 'facebook' ? 30 : _context.t0 === 'instagram' ? 30 : _context.t0 === 'twitter' ? 30 : _context.t0 === 'linkedin' ? 30 : _context.t0 === null ? 32 : _context.t0 === '' ? 32 : 34;
                    break;

                case 28:
                    analytics.medium = 'organic';
                    return _context.abrupt('break', 36);

                case 30:
                    analytics.medium = 'social';
                    return _context.abrupt('break', 36);

                case 32:
                    analytics.medium = 'direct';
                    return _context.abrupt('break', 36);

                case 34:
                    analytics.medium = 'referral';
                    return _context.abrupt('break', 36);

                case 36:
                    _context.next = 38;
                    return (0, _setAnalyticsSaga2.default)({ payload: analytics });

                case 38:
                    return _context.abrupt('return', analytics);

                case 39:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}